"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9781],{

/***/ 59781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LivescoreSeasonTable_LivescoreSeasonTable; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/context/LivescoreSeasonTableContext.tsx
var LivescoreSeasonTableContext = __webpack_require__(25950);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/cn.ts + 1 modules
var cn = __webpack_require__(72802);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreSeasonTable/subcomponents/LivescoreSeasonTableTypePicker.tsx



var types = [
    {
        label: "OG\xd3LNA",
        value: "total"
    },
    {
        label: "U SIEBIE",
        value: "home"
    },
    {
        label: "NA WYJEŹDZIE",
        value: "away"
    }, 
];
var LivescoreSeasonTableTypePicker = function() {
    var ref = (0,LivescoreSeasonTableContext/* useSeasonTable */.iB)(), type = ref.type, setType = ref.setType, showForm = ref.showForm, setShowForm = ref.setShowForm, seasonTable = ref.seasonTable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full rounded-full sm:px-3 px-1.5 py-1 sm:py-1.5 flex items-center text-xxs text-gray-400 font-semibold gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dark:bg-gray-650 bg-white_theme-100 w-full rounded-full sm:px-3 px-1.5 py-1 sm:py-1.5 flex items-center text-xxs text-gray-400 font-semibold gap-2",
                children: types.map(function(param) {
                    var label = param.label, value = param.value;
                    return (seasonTable === null || seasonTable === void 0 ? void 0 : seasonTable[value]) && Object.keys(seasonTable === null || seasonTable === void 0 ? void 0 : seasonTable[value]).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return setType(value);
                        },
                        className: (0,cn.cn)("w-full py-2 rounded-full border border-transparent transition-all sm:text-xxs text-[8px]", type === value && " dark:bg-black-500 bg-white border dark:border-border-400 border-white_theme-100 text-primary-600"),
                        children: label
                    }, value);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function() {
                    return setShowForm(function(prev) {
                        return !prev;
                    });
                },
                className: (0,cn.cn)("py-2 rounded-full border border-transparent transition-all sm:text-xxs text-[8px] flex items-center gap-2"),
                children: [
                    "FORMA",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-7 w-12 rounded-full dark:bg-gray-450 bg-gray-250 relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,cn.cn)("bg-white dark:bg-black w-5 h-5 rounded-full absolute top-1 transition-all", showForm ? "right-1 bg-primary-600 dark:bg-primary-600" : "right-6"),
                            "aria-hidden": true
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var subcomponents_LivescoreSeasonTableTypePicker = (LivescoreSeasonTableTypePicker);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/atoms/Skeleton/Skeleton.tsx
var Skeleton = __webpack_require__(28254);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreSeasonTable/subcomponents/LivescoreSeasonTableSkeleton.tsx



var LivescoreSeasonTableSkeleton = function() {
    // Generate skeleton rows (8 teams is typical for many league tables)
    var skeletonRows = Array.from({
        length: 8
    }, function(_, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            className: "text-[12px] group",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: (0,cn.cn)("pl-4 dark:bg-black-400 bg-white_theme-50 py-2.5 w-12 flex justify-center", index === 7 && "rounded-bl-3xl"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "rounded-full w-[21px] h-[21px]"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "w-auto pl-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2 group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "w-4 h-4 rounded-full"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "h-3 w-32"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 w-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "h-3 w-4 mx-auto"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 w-16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "h-3 w-8 mx-auto"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: (0,cn.cn)("text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 w-14 pr-6", index === 7 && "rounded-br-3xl"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "h-3 w-6 mx-auto"
                    })
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full border dark:border-border-400 border-gray-250 rounded-t-3xl rounded-b-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-2 px-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-2 px-4 py-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    className: "h-8 w-full !rounded-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                    className: "border-b dark:border-border-400 border-gray-250",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        className: "text-xxs text-gray-400",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "text-center py-3 w-12 pl-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    className: "h-3 w-3 mx-auto"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "text-left py-3 w-auto pl-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    className: "h-3 w-16"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "text-center py-3 w-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    className: "h-3 w-3 mx-auto"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "text-center py-3 w-16",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    className: "h-3 w-3 mx-auto"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "text-center py-3 w-14 pr-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    className: "h-3 w-3 mx-auto"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                    children: skeletonRows
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-2 mt-6",
                children: Array.from({
                    length: 2
                }, function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "w-3.5 h-3.5 rounded-full"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "h-3 w-24"
                            })
                        ]
                    }, "promotion-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-2 mt-2",
                children: Array.from({
                    length: 1
                }, function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "w-3.5 h-3.5 rounded-full"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "h-3 w-20"
                            })
                        ]
                    }, "relegation-".concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var subcomponents_LivescoreSeasonTableSkeleton = (LivescoreSeasonTableSkeleton);

// EXTERNAL MODULE: ./src/components/atoms/LivescoreEntityLink/LivescoreEntityLink.tsx
var LivescoreEntityLink = __webpack_require__(61638);
;// CONCATENATED MODULE: ./src/components/molecules/LivescoreSeasonTable/LivescoreSeasonTable.tsx








var _slug;
var LivescoreSeasonTableElement = function(param) {
    var last = param.last, competitor = param.competitor, form = param.form, color = param.color, score = param.score, highlight = param.highlight, isAhref = param.isAhref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: "sm:text-[12px] text-[9px] group text-black dark:text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: (0,cn.cn)("md:pl4 group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 md:w-12 w-9 flex justify-center", last && "rounded-bl-3xl", highlight && "dark:dark:!bg-green-600 !bg-primary-150"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: color ? {
                        backgroundColor: color
                    } : {},
                    className: (0,cn.cn)("!text-white rounded-full w-[21px] h-[21px] flex items-center justify-center font-bold sm:text-[9px] text-[7px]", !color && "dark:bg-gray-650 bg-white_theme-100 dark:!text-white !text-black"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "ml-0.5 sm:mt-0.5",
                        children: [
                            competitor.rank,
                            "."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: (0,cn.cn)("w-auto md:pl-4 pl-2 group-odd:dark:bg-black-400 group-odd:bg-white_theme-50", highlight && "dark:!bg-green-600 !bg-primary-150"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LivescoreEntityLink/* default */.Z, {
                    href: "/livescore/team/".concat((_slug = competitor.competitor.slug) !== null && _slug !== void 0 ? _slug : competitor.competitor.id),
                    className: (0,cn.cn)("flex items-center gap-2 py-2.5", highlight && "dark:!bg-green-600 !bg-primary-150"),
                    isAhref: isAhref,
                    children: [
                        competitor.competitor.logo_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-4 h-4 relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: competitor.competitor.logo_url,
                                alt: competitor.competitor.name,
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "bg-primary-600 rounded-full w-4 h-4 flex items-center justify-center text-[6px]",
                            children: competitor.competitor.abbreviation
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-semibold !line-clamp-1 overflow-ellipsis",
                            children: competitor.competitor.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: (0,cn.cn)("sm:w-12 w-8 group-odd:dark:bg-black-400 group-odd:bg-white_theme-50", highlight && "dark:!bg-green-600 !bg-primary-150"),
                children: score && highlight && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "dark:text-black text-white font-gameplay sm:px-2 px-1 pb-0.5 pt-[3px] bg-primary-600 sm:text-xxs text-[7px] rounded-[2.66px]",
                    children: [
                        score.home.score,
                        ":",
                        score.away.score
                    ]
                })
            }),
            form ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: (0,cn.cn)("text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 w-14 pr-6", last && "rounded-br-3xl", highlight && "dark:!bg-green-600 !bg-primary-150"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-white flex gap-2 float-right",
                    children: competitor.competitor.form ? competitor.competitor.form.split("").map(function(result) {
                        return result === "W" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sm:w-5 sm:h-5 w-3.5 h-3.5 rounded-[2.66px] bg-[#06C000] flex items-center justify-center font-bold sm:text-xxs text-[8px]",
                            children: "Z"
                        }) : result === "D" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sm:w-5 sm:h-5 w-3.5 h-3.5 rounded-[2.66px] bg-[#FFA600] flex items-center justify-center font-bold sm:text-xxs text-[8px]",
                            children: "R"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sm:w-5 sm:h-5 w-3.5 h-3.5 rounded-[2.66px] bg-[#FF0004] flex items-center justify-center font-bold sm:text-xxs text-[8px]",
                            children: "P"
                        });
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs text-gray-400",
                        children: "Brak informacji"
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: (0,cn.cn)("text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 sm:w-8 w-6", highlight && "dark:!bg-green-600 !bg-primary-150"),
                        children: competitor.played
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                        className: (0,cn.cn)("text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 sm:w-16 w-12", highlight && "dark:!bg-green-600 !bg-primary-150"),
                        children: [
                            competitor.goals.for,
                            ":",
                            competitor.goals.against
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: (0,cn.cn)("text-center group-odd:dark:bg-black-400 group-odd:bg-white_theme-50 py-2.5 sm:w-14 w-10 pr-6", last && "rounded-br-3xl", highlight && "dark:!bg-green-600 !bg-primary-150"),
                        children: competitor.points
                    })
                ]
            })
        ]
    });
};
var LivescoreSeasonTable = function(param) {
    var score = param.score;
    var ref = (0,LivescoreSeasonTableContext/* useSeasonTable */.iB)(), seasonTable = ref.seasonTable, fetchSeasonTable = ref.fetchSeasonTable, loading = ref.loading, type = ref.type, showForm = ref.showForm, outcomesUp = ref.outcomesUp, outcomesDown = ref.outcomesDown, seasonId = ref.seasonId, season = ref.season;
    var ref1 = (0,react.useState)(seasonId), lastSeasonId = ref1[0], setLastSeasonId = ref1[1];
    (0,react.useEffect)(function() {
        if (!seasonTable || seasonId !== lastSeasonId) {
            fetchSeasonTable();
            setLastSeasonId(seasonId);
        }
    }, [
        seasonTable,
        seasonId
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(subcomponents_LivescoreSeasonTableSkeleton, {});
    }
    if (!seasonTable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "text-xs text-gray-400",
            children: "Brak informacji"
        });
    }
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full border dark:border-border-400 border-gray-250 rounded-t-3xl rounded-b-xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-2 px-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "space-y-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(subcomponents_LivescoreSeasonTableTypePicker, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                className: "w-full",
                                children: seasonTable === null || seasonTable === void 0 ? void 0 : seasonTable[type].map(function(group, index) {
                                    var ref, ref1, ref3;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                className: "border-b dark:border-border-400 border-gray-250",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    className: "md:text-xxs text-[8px] text-gray-400",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            className: "text-center py-3 sm:w-12 w-9 sm:pl-4",
                                                            children: "#"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            className: "text-left py-3 w-auto sm:pl-4 pl-2 !line-clamp-1 overflow",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "!line-clamp-1 overflow-ellipsis",
                                                                children: (seasonTable === null || seasonTable === void 0 ? void 0 : seasonTable[type]) && (seasonTable === null || seasonTable === void 0 ? void 0 : seasonTable[type].length) > 1 ? group.name : "DRUŻYNA"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            className: "sm:w-12 w-8"
                                                        }),
                                                        showForm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                                            className: "text-center py-3 w-[132px]",
                                                            children: [
                                                                "OSTATNIE ",
                                                                (ref = group.standings[0].competitor.form) === null || ref === void 0 ? void 0 : ref.length,
                                                                " MECZ",
                                                                ((ref1 = group.standings[0].competitor.form) === null || ref1 === void 0 ? void 0 : ref1.length) && ((ref3 = group.standings[0].competitor.form) === null || ref3 === void 0 ? void 0 : ref3.length) < 5 ? "E" : "\xd3W"
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "text-center py-3 sm:w-8 w-6",
                                                                    children: "M"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "text-center py-3 sm:w-16 w-12",
                                                                    children: "B"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    className: "text-center py-3 sm:w-14 w-10 pr-6",
                                                                    children: "P"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                children: group.standings.map(function(team, index) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LivescoreSeasonTableElement, {
                                                        competitor: team,
                                                        last: index === group.standings.length - 1,
                                                        form: showForm,
                                                        color: team.outcome ? (ref2 = outcomesUp.get(team.outcome)) !== null && ref2 !== void 0 ? ref2 : outcomesDown.get(team.outcome) : undefined,
                                                        score: score,
                                                        highlight: [
                                                            score === null || score === void 0 ? void 0 : score.away.id,
                                                            score === null || score === void 0 ? void 0 : score.home.id
                                                        ].includes(team.competitor.id),
                                                        isAhref: season === null || season === void 0 ? void 0 : season.seoLinks
                                                    }, index);
                                                })
                                            })
                                        ]
                                    });
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-black dark:text-white sm:mt-6 mt-4 mb-2 sm:mb-0",
                children: [
                    outcomesUp.size > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-2",
                        children: Array.from(outcomesUp.keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-3.5 h-3.5 rounded-full",
                                        style: {
                                            backgroundColor: outcomesUp.get(key)
                                        },
                                        "aria-hidden": true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-xxs",
                                        children: [
                                            "Awans",
                                            " ",
                                            key !== "Promotion" && key !== "Awans" && "- ".concat(key.replace("Promotion", "").replace("Awans", ""))
                                        ]
                                    })
                                ]
                            }, key);
                        })
                    }),
                    outcomesDown.size > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-2 mt-2",
                        children: Array.from(outcomesDown.keys()).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-3.5 h-3.5 rounded-full",
                                        style: {
                                            backgroundColor: outcomesDown.get(key)
                                        },
                                        "aria-hidden": true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-xxs",
                                        children: [
                                            "Spadek",
                                            " ",
                                            key !== "Relegation" && key !== "Spadek" && "- ".concat(key.replace("Relegation", "").replace("Spadek", ""))
                                        ]
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LivescoreSeasonTable_LivescoreSeasonTable = (LivescoreSeasonTable);


/***/ }),

/***/ 25950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iB": function() { return /* binding */ useSeasonTable; },
/* harmony export */   "vb": function() { return /* binding */ LivescoreSeasonTableProvider; }
/* harmony export */ });
/* unused harmony export types */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_livescore_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79800);
/* harmony import */ var _AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64574);






var LivescoreSeasonTableContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var types = (/* unused pure expression or super */ null && ([
    "total",
    "home",
    "away"
]));
var LivescoreSeasonTableProvider = function(param) {
    var children = param.children, seasonId = param.seasonId, initSeasonTable = param.initSeasonTable, initOutcomes = param.initOutcomes, leagueName = param.leagueName, initSeason = param.initSeason;
    var ref, ref1;
    var appendJsonLd = (0,_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .useApp */ .q)().appendJsonLd;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initSeasonTable !== null && initSeasonTable !== void 0 ? initSeasonTable : null), seasonTable = ref2[0], setSeasonTable = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initSeasonTable ? false : true), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("total"), type = ref4[0], setType = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showForm = ref5[0], setShowForm = ref5[1];
    var ref6;
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initOutcomes ? new Map((ref6 = (ref = initOutcomes.up) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var to = param.to, color = param.color;
        return [
            to,
            color
        ];
    })) !== null && ref6 !== void 0 ? ref6 : []) : new Map()), outcomesUp = ref7[0], setOutcomesUp = ref7[1];
    var ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initOutcomes ? new Map((ref8 = (ref1 = initOutcomes.down) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
        var to = param.to, color = param.color;
        return [
            to,
            color
        ];
    })) !== null && ref8 !== void 0 ? ref8 : []) : new Map()), outcomesDown = ref9[0], setOutcomesDown = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initSeason), season = ref10[0], setSeason = ref10[1];
    var fetchSeasonTable = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var seasonTableResponse, ref, ref1, ref2, ref3, ref4, ref5;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    return [
                        4,
                        _api_livescore_client__WEBPACK_IMPORTED_MODULE_2__/* .livescoreClient.apiSeasonTableSeasonIdGet */ .Z.apiSeasonTableSeasonIdGet({
                            seasonId: seasonId
                        })
                    ];
                case 1:
                    seasonTableResponse = _state.sent();
                    if (seasonTableResponse.data.data.standings) {
                        ;
                        setSeasonTable(seasonTableResponse.data.data.standings);
                        ;
                        setOutcomesUp(new Map((ref4 = (ref = seasonTableResponse.data.data.outcome) === null || ref === void 0 ? void 0 : (ref1 = ref.up) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                            var to = param.to, color = param.color;
                            return [
                                to,
                                color
                            ];
                        })) !== null && ref4 !== void 0 ? ref4 : []));
                        ;
                        setOutcomesDown(new Map((ref5 = (ref2 = seasonTableResponse.data.data.outcome) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.down) === null || ref3 === void 0 ? void 0 : ref3.map(function(param) {
                            var to = param.to, color = param.color;
                            return [
                                to,
                                color
                            ];
                        })) !== null && ref5 !== void 0 ? ref5 : []));
                        setSeason(seasonTableResponse.data.data.season);
                    }
                    setLoading(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        seasonId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var jsonLd = {
            "@context": "https://schema.org",
            "@type": "SportsOrganization",
            sport: "Soccer"
        };
        if (leagueName) {
            jsonLd.name = leagueName;
        }
        if (season) {
            jsonLd.startDate = season.start_date;
            jsonLd.endDate = season.end_date;
            if (season.country) {
                jsonLd.location = {
                    "@type": "Country",
                    name: season.country
                };
            }
        }
        appendJsonLd(jsonLd);
    }, [
        leagueName,
        season === null || season === void 0 ? void 0 : season.name
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LivescoreSeasonTableContext.Provider, {
        value: {
            seasonTable: seasonTable,
            fetchSeasonTable: fetchSeasonTable,
            loading: loading,
            type: type,
            setType: setType,
            showForm: showForm,
            setShowForm: setShowForm,
            outcomesUp: outcomesUp,
            outcomesDown: outcomesDown,
            seasonId: seasonId,
            season: season
        },
        children: children
    });
};
var useSeasonTable = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LivescoreSeasonTableContext);
    if (!context) {
        throw new Error("useSeasonTable must be used within an LivescoreSeasonTableProvider");
    }
    return context;
};


/***/ })

}]);